import { render, staticRenderFns } from "./sales-report.vue?vue&type=template&id=46c8e53a"
import script from "./sales-report.vue?vue&type=script&lang=ts"
export * from "./sales-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports